import React from "react";
import PropTypes from "prop-types";
import { Table, Spin, Grid, Button, Popconfirm, message } from "antd";
const { useBreakpoint } = Grid;

const StockOpnameTableHistory = ({
  loading,
  data,
  pagination,
  onPaginationChange,
  dispatch,
  userData,
}) => {
  const screens = useBreakpoint();

  const handleTableOnChange = (paginationParams, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });

    if (onPaginationChange && paginationParams) {
      onPaginationChange(paginationParams.current, paginationParams.pageSize);
    }
  };



  const columns = [
    {
      title: "Checked Date",
      dataIndex: "checkedDate",
      key: "checkedDate",
      sorter: (a, b) => new Date(a.checkedDate) - new Date(b.checkedDate),
      render: (date) =>
        date ? new Date(date).toLocaleDateString("id-ID") : "-",
    },
    {
      title: "Counter Code",
      dataIndex: "counterCode",
      key: "counterCode",
      sorter: (a, b) => (a.counterCode || "").localeCompare(b.counterCode || ""),
    },
    {
      title: "Checker",
      dataIndex: "checker",
      key: "checker",
      sorter: (a, b) => (a.checker || "").localeCompare(b.checker || ""),
    },
    {
      title: "Barcode",
      dataIndex: "barcode",
      key: "barcode",
      sorter: (a, b) => (a.barcode || "").toString().localeCompare((b.barcode || "").toString()),
    },
    {
      title: "Article Name",
      dataIndex: "articleName",
      key: "articleName",
      sorter: (a, b) => (a.articleName || "").localeCompare(b.articleName || ""),
      render: (name) => name || "-",
    },
    {
      title: "Color",
      dataIndex: "colorName",
      key: "colorName",
      sorter: (a, b) => (a.colorName || "").localeCompare(b.colorName || ""),
      render: (name) => name || "-",
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",
      sorter: (a, b) => (a.size || "").localeCompare(b.size || ""),
      render: (size) => size || "-",
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      sorter: (a, b) => (a.sku || "").localeCompare(b.sku || ""),
      render: (sku, record) =>
        userData?.counterCode === "ECOMMRI" ? sku || "-" : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
      render: (value) => {
        if (value === "A") return "Approve";
        if (value === "R") return "Reject";
        return value; // fallback to display the raw value for other statuses
      }
    },
    {
      title: "Adjustment Quantity",
      dataIndex: "stockAdjustment",
      key: "stockAdjustment",
      sorter: (a, b) => (a.stockAdjustment || 0) - (b.stockAdjustment || 0),
      render: (value, record) => {
        // If status is "A" (Approve) and stockAdjustment is null, display 0
        if (record.status === "A" && (value === null || value === undefined)) {
          return 0;
        }
        return value;
      },
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        padding: screens.xs ? "10px" : "20px",
      }}
    >
      <Spin spinning={loading} tip="Loading stock opname data...">
        <Table
          columns={columns}
          dataSource={data}
          onChange={handleTableOnChange}
          pagination={{
            current: pagination?.current || 1,
            pageSize: pagination?.pageSize || (screens.xs ? 5 : 10),
            total: pagination?.total || 0,
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          scroll={screens.xs ? { x: "max-content" } : undefined}
          rowKey="_id"
        />
      </Spin>
    </div>
  );
};

StockOpnameTableHistory.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  pagination: PropTypes.object,
  onPaginationChange: PropTypes.func,
  dispatch: PropTypes.func,
  updateStockQuantity: PropTypes.func.isRequired,
  callRefetch: PropTypes.func.isRequired,
};

export default StockOpnameTableHistory;
